<div class="p-20 fx-row fx-wrap align-items-center justify-content-center text-center">
    <div class="fx-flex-100 align-items-center justify-content-center text-center">
        <span class="title mb-10 text-center">{{'CREATE_ORGANIZATION_DIALOG.TITLE' | translate}}</span>
    </div>
    <span class="text mt-20">{{'CREATE_ORGANIZATION_DIALOG.INSTRUCTIONS' | translate:organization}}</span>
    <span class="text mt-10 bold main">{{'CREATE_ORGANIZATION_DIALOG.ORGANIZATION_SECTION' |
        translate:organization}}</span>
    <div class="fx-flex-100 fx-row fx-wrap align-items-center justify-content-center mt-20">
        <app-upload-picture [src]="organizationToCreate.logo" [height]="150" class="mb-20 fx-flex-100"
            (pictureChange)="onLogoChange($event)" roleBasedElement
            [roles]="['SUPERADMIN','ADMIN']"></app-upload-picture>
        <app-input [placeholder]="('ORGANIZATION.NAME' | translate) + '...'" type="text" class="mb-10 fx-flex-100"
            [(value)]="organizationToCreate.name" [error]="errors['name']" [bottomWrapper]="true"></app-input>
        <app-input [placeholder]="('ORGANIZATION.HEADQUARTERS' | translate) + '...'" type="text"
            class="mb-10 fx-flex-100" [(value)]="organizationToCreate.headquartersAddress"
            [error]="errors['headquartersAddress']" [bottomWrapper]="true"></app-input>
        <app-select class="fx-flex-100 mb-10" [value]="organizationToCreate.clientType"
            [options]="clientTypeOptions" [emitOnInit]="false" [clearable]="false"
            (change)="onClientTypeChange($event)" [error]="errors['clientType']"
            label="{{'CREATE_ORGANIZATION_DIALOG.CLIENT_TYPE' | translate}}" [bottomWrapper]="true"></app-select>
    </div>
    <span class="text mt-10 bold main">{{'CREATE_ORGANIZATION_DIALOG.ADMIN_SECTION' |
        translate:organization}}</span>
    <span class="small light fx-flex-100 mt-5">{{'CREATE_ORGANIZATION_DIALOG.ADMIN_OPTIONAL' | translate}}</span>
    <div class="fx-flex-100 fx-row fx-wrap align-items-center justify-content-center mt-20">
        <div class="fx-flex-100 fx-row align-items-start justify-content-start mb-10">
            <div class="fx-flex-50 pr-10">
                <app-input [placeholder]="('USER.FIRSTNAME' | translate) + '...'" type="text" class="fx-flex-100"
                    [(value)]="userToInvite.firstName" [error]="errors['firstName']" [bottomWrapper]="true"></app-input>
            </div>
            <div class="fx-flex-50 pl-10">
                <app-input [placeholder]="('USER.LASTNAME' | translate) + '...'" type="text" class="fx-flex-100"
                    [(value)]="userToInvite.lastName" [error]="errors['lastName']" [bottomWrapper]="true"></app-input>
            </div>
        </div>

        <app-input [placeholder]="('USER.EMAIL' | translate) + '...'" type="text" class="mb-10 fx-flex-100"
            [(value)]="userToInvite.email" [error]="errors['email']" [bottomWrapper]="true"></app-input>
    </div>
    <mat-divider class="fx-flex-100 mv-20"></mat-divider>
    <div class="fx-row align-items-center justify-content-center fx-flex-100">
        <button class="button fx-flex mr-10" (click)="onCancel()">{{'ACTIONS.CANCEL' | translate}}</button>
        <button class="main-button fx-flex ml-10" (click)="onCreateAndInvite()" [class.disabled]="isDisabled()"
            [disabled]="isDisabled()">{{(hasAdministrator() ? 'ACTIONS.CREATE_AND_INVITE' : 'ACTIONS.CREATE')
            | translate}}</button>
    </div>
</div>
